import { Button, Paper, Stack, Typography, useTheme } from '@mui/material'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { CircleCheckIcon } from '../../../icons'

export const SuccessMessage = () => {
  const theme = useTheme()
  return (
    <Stack
      spacing={1}
      px={3}
      py={4}
      width={{ md: 540, xs: '100%' }}
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        color: theme.palette.primary.dark,
      }}
      alignItems="center"
    >
      <CircleCheckIcon sx={{ fontSize: '5rem', color: 'transparent' }} />
      <Stack>
        <Typography fontSize="1.25rem" fontWeight={600} color="text.primary">
          You're in. Your water test kit is on its way.
        </Typography>

        <Typography fontSize="1rem" color={theme.palette.grey[600]} fontWeight={500}>
          You’ll get your kit in just a few days.
        </Typography>
      </Stack>
      <Paper
        elevation={0}
        sx={{
          borderRadius: theme.shape.borderRadius,
          background: theme.palette.grey[0],
          width: '100%',
          p: '0.75rem',
          textAlign: 'left',
        }}
      >
        <Typography variant="overline" sx={{ fontSize: '1rem', mb: '1rem' }}>
          See whats next:
        </Typography>
        <Typography fontWeight={600}>The smart system that works with your test.</Typography>
        <Typography sx={{ mb: '0.75rem' }}>
          Be among the first to reserve your system and unlock exclusive pre-order perks.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          href="https://sippsafely.com"
          onClick={() => {
            ReactPixel.trackCustom('click', { id: 'learn_more', name: 'Learn More about Sipp' })
            ReactGA.event({
              action: 'click',
              category: 'User event tracking',
              label: 'learn_more_about_sipp',
            })
          }}
        >
          Learn More About SIPP
        </Button>
      </Paper>
    </Stack>
  )
}
